import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppProvider";
import { getFirebaseDB } from "../../util/FirebaseUtil";
import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { signInAnonymously } from "firebase/auth";
import { cardDivStyle } from "../../styles/styles";

const UserPage = () => {
  const appState = useContext(AppContext);
  //Functional states
  const [detailsChanged, setDetailsChanged] = useState(false);
  const [saveInProgress, setSaveInProgress] = useState(false);
  const [loginInProgress, setLoginInProgress] = useState(false);
  //Form states
  const [nickname, setNickname] = useState();

  useEffect(() => {
    if (!detailsChanged) {
      setNickname(appState.live.user_nickname);
    }
  }, [appState]);

  const handleNicknameChange = (e) => {
    setDetailsChanged(true);
    setNickname(e.target.value);
  };

  const handleLogin = (e) => {
    setLoginInProgress(true);
    try {
      signInAnonymously(appState.firebase.auth)
        .then((user) => {
          setLoginInProgress(false);
        })
        .catch((err) => {
          window.alert(`Login failed\n${err}`);
        });
    } catch (err) {
      window.alert(`Login failed\n${err}`);
    }
  };

  const handleSave = (e) => {
    setSaveInProgress(true);
    try {
      if (appState.firebase.db) {
        const docRef = doc(appState.firebase.db, "users", appState.live.uid);
        const uploadData = {
          user_nickname: nickname,
          updated: serverTimestamp(),
        };

        if (appState.live.userDocExists) {
          console.log("Updating user account");
          setDoc(docRef, uploadData, { merge: true })
            .then((docRef) => {
              console.log("User doc updated", docRef);
              setSaveInProgress(false);
              setDetailsChanged(false);
              appState.setLive("newUserDoc", true);
            })
            .catch((err) => {
              window.alert(`Saving failed\n${err}`);
              setSaveInProgress(false);
            });
        } else {
          console.log("Creating new user doc");
          const collectionRef = collection(appState.firebase.db, "users");
          setDoc(
            docRef,
            {
              ...uploadData,
              created: serverTimestamp(),
            },
            { merge: true }
          )
            .then(() => {
              console.log("User doc created");
              appState.setLive("newUserDoc", true);
              setSaveInProgress(false);
              setDetailsChanged(false);
            })
            .catch((err) => {
              window.alert(`Saving failed\n${err}`);
              setSaveInProgress(false);
            });
        }
      } else {
        window.alert(
          "App is not initialized correctly. Please refresh the page."
        );
      }
    } catch (err) {
      window.alert(`Saving failed\n${err}`);
      setSaveInProgress(false);
    }
  };

  const formValid = nickname;

  const saveNeeded = detailsChanged || !appState.live.userDocExists;

  return (
    <div style={cardDivStyle}>
      {appState.derived.user_online ? (
        <>
          <h1>Your Information</h1>
          <p>Change your details here, then click submit when you are done.</p>
        </>
      ) : (
        <>
          <h1>Welcome!</h1>
          <p>Please enter the details and then click save!</p>
        </>
      )}
      {appState.live.uid ? (
        <>
          <label htmlFor="nameInput" className="form-label">
            Enter Your Name*
          </label>
          <br />
          <input
            id="nameInput"
            className="form-control"
            value={nickname}
            onChange={handleNicknameChange}
          />
          <br />
          {!formValid && (
            <p style={{ color: "darkRed" }}>
              <em>Cannot save until required fields are filled out</em>
            </p>
          )}

          {saveNeeded && (
            <button
              className="btn btn-success"
              disabled={!formValid || saveInProgress}
              onClick={handleSave}
            >
              {saveInProgress ? "Saving..." : "Save"}
            </button>
          )}
        </>
      ) : (
        <>
          <label>Click on login to begin</label>
          <br />
          <button
            className="btn btn-primary"
            onClick={handleLogin}
            disabled={loginInProgress}
          >
            {loginInProgress ? "Logging in..." : "Login"}
          </button>
        </>
      )}
    </div>
  );
};

export { UserPage };
